import { nsModel } from "../../lib/namespace";

export const meterNS = nsModel("meter");
